import { render, staticRenderFns } from "./TaxReturnWorthChangeSection.vue?vue&type=template&id=00d43fe7&scoped=true&"
import script from "./TaxReturnWorthChangeSection.vue?vue&type=script&lang=js&"
export * from "./TaxReturnWorthChangeSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d43fe7",
  null
  
)

export default component.exports